import { render, staticRenderFns } from "./AgentDetail2.vue?vue&type=template&id=54e9201f"
import script from "./AgentDetail2.vue?vue&type=script&lang=js"
export * from "./AgentDetail2.vue?vue&type=script&lang=js"
import style0 from "./AgentDetail2.vue?vue&type=style&index=0&id=54e9201f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports